module.exports = __webpack_public_path__ + "img/header_old.fcffaf0c.png";